export const ZoomHowItWorks: React.FC = () => {
  return (
    <div>
      <p>
        Zocks' Zoom integration allows you to have your Zocks AI Notetaker with you on your Zoom meetings so that you can focus on your client while Zocks
        captures accurate, actionable, and 100% recording-free notes, so you never miss a detail.
      </p>
      <p>
        With our native Zoom plugin you can access meeting prep materials, real-time client insights, and task management live during your meeting, without ever
        leaving Zoom.
      </p>
    </div>
  )
}
